<template>
  <div>
    <label
      v-if="label"
      class="input-label"
      :class="{ 'input-label--small': small }"
      >{{ label }}</label
    >
    <div
      class="input-wrapper"
      :class="{'error-border': errorMessage}">
      <input
        type="datetime-local"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :min="minDate"
        :max="maxDate"
        class="datetime-input uih6"
        step="60" />
    </div>
    <div
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </div>
    <p
      v-if="helpText"
      class="help-text">
      {{ helpText }}
    </p>
  </div>
</template>

<script>
export default {
  name: "SixDateTimeInput",
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    helpText: {
      type: String,
      default: "",
    },
    min: {
      type: Date,
      default: null,
    },
    max: {
      type: Date,
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    minDate() {
      return this.min ? this.formatDateForInput(this.min) : null;
    },
    maxDate() {
      return this.max ? this.formatDateForInput(this.max) : null;
    },
  },
  methods: {
    // Formats a Date object into 'YYYY-MM-DDTHH:MM:SS' for the input element
    formatDateForInput(date) {
      const pad = (num) => num.toString().padStart(2, "0");
      const year = date.getUTCFullYear();
      const month = pad(date.getUTCMonth() + 1);
      const day = pad(date.getUTCDate());
      const hours = pad(date.getUTCHours());
      const minutes = pad(date.getUTCMinutes());
      const seconds = pad(date.getUTCSeconds());
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
  },
};
</script>

<style scoped>
.input-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--color-text);
}

.input-label--small {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-deactive-text);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.input-wrapper {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  background: #fff;
}

.input-wrapper.error-border {
  border-color: var(--color-danger);
}

.datetime-input {
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: transparent;
  font-family: var(--font-family);
  line-height: normal;
}

.datetime-input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  filter: invert(0.5);
}

.error-message {
  color: var(--color-danger);
  font-size: 14px;
  margin-top: 4px;
}

.help-text {
  font-size: 14px;
  color: var(--color-deactive-text);
  margin-top: 4px;
}
</style>
